export const isFileLike = (v) =>
  (typeof File !== "undefined" && v instanceof File) ||
  (typeof Blob !== "undefined" && v instanceof Blob);

export const appendIfFile = (fd, fieldName, val) => {
  if (isFileLike(val)) {
    fd.append(fieldName, val);
  }
};
